type HttpErrorLike = {
  name?: unknown
  status?: unknown
  message?: unknown
}

const EXPECTED_NATIVE_ASSET_DENIAL = 'access restricted to users whose native asset is USDC'

export const isExpectedDepositEligibilityError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false

  const errorLike = error as HttpErrorLike

  return (
    errorLike.name === 'ApiHttpError' &&
    errorLike.status === 403 &&
    typeof errorLike.message === 'string' &&
    errorLike.message.includes(EXPECTED_NATIVE_ASSET_DENIAL)
  )
}
